// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"qK-z","carouselContainer":"rK-z"};